<template>
  <v-app>
    <SideBarAdmin />
    <!-- <SideHeader /> -->

    <v-card-title>Summary</v-card-title>
    <div class="grey lighten-4">
      <v-row>
        <v-col cols="4" sm="4" md="4"
          ><v-card-text class="black--text">
            <v-chip class="primary">REGISTERED CATEGORIES: {{ totalCategories }}</v-chip>
          </v-card-text>

          <v-card-text class="black--text">
            <v-chip class="primary">PRODUCT REGISTERED: {{ totalProducts }}</v-chip>
          </v-card-text>

          <v-card-text class="black--text">
            <v-chip class="primary">ORDER PROFIT: Rp. {{ totalProfit }}</v-chip>
          </v-card-text>

          <v-card-text class="black--text">
            <v-chip class="primary">CASH FLOW: Rp. {{ totalCashflow }}</v-chip>
          </v-card-text>

          <v-card-text class="black--text">
            <v-chip class="primary">TOTAL ORDER BRUTO: Rp. {{ totalOrders }}</v-chip>
          </v-card-text>

          <v-card-text class="black--text">
            <v-chip class="primary">TOTAL VALUATION: Rp.{{ totalValuations }}</v-chip>
          </v-card-text>
        </v-col>
        <v-col cols="4" sm="4" md="4">
          <v-card-text>
            <v-data-table
              ref="vDataTable"
              :headers="headers"
              :items="ordersMarketPlace"
              hide-default-footer
              class="elevation-0"
            >
              <template #item="{ item, index, headers }">
                <tr>
                  <td>
                    {{ item.id }}
                  </td>
                  <td>
                    {{ item.total_bill }}
                  </td>
                  <td>
                    {{ item.payment_card_number }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-col>
        <v-col cols="4" sm="4" md="4"
          ><v-card-text>
            <v-sheet max-width="100%" height="100%" class="mx-auto"></v-sheet>
            <v-chip class="primary"> Statistic Of Orders / Day </v-chip>
            <LineChartGenerator
              :chart-options="chartOptions"
              :chart-data="chartData"
              :chart-id="chartId"
              :dataset-id-key="datasetIdKey"
              :plugins="plugins"
              :css-classes="cssClasses"
              :styles="styles"
              :width="width"
              :height="height"
            /> </v-card-text
        ></v-col>
      </v-row>
    </div>
  </v-app>
</template>
<script>
import SideBarAdmin from "../components/SideBarAdmin.vue";
// import SideHeader from '../components/SideHeader.vue';
import { mapGetters, mapActions } from "vuex";

import { Line as LineChartGenerator } from "vue-chartjs/legacy";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);

export default {
  components: {
    SideBarAdmin,
    // SideHeader,
    LineChartGenerator,
  },
  props: {
    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 50,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      totalCategories: "",
      totalProducts: "",
      totalProfit: "",
      totalCashflow: "",
      totalOrders: "",
      totalValuations: "",
      chartData: {
        labels: [],
        datasets: [
          {
            label: "Count Orders",
            backgroundColor: "blue",
            data: [],
          },
        ],
      },
      ordersMarketPlace: [],
      headers: [
        { text: "Total", value: "id" },
        { text: "Price Total", value: "total_bill" },
        { text: "Market Place", value: "payment_card_number" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },
  methods: {
    ...mapActions({
      setAlert: "alert/set",
      setAuth: "auth/set",
    }),
    isHome() {
      return this.$router.push({ path: "/" });
    },
    countCategories() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let url = "/admin/count-categories";
      this.axios
        .get(url, config)
        .then((response) => {
          let { data } = response.data;
          this.totalCategories = data[0].countCategories;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    countProducts() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let url = "/admin/count-products";
      this.axios
        .get(url, config)
        .then((response) => {
          let { data } = response.data;
          this.totalProducts = data[0].countProducts;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    countProfit() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let url = "/admin/count-profit";
      this.axios
        .get(url, config)
        .then((response) => {
          let { data } = response.data;
          this.totalProfit = data[0].total;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    countCashflows() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let url = "/admin/count-cashflows";
      this.axios
        .get(url, config)
        .then((response) => {
          let { data } = response.data;
          this.totalCashflow = data[0].saldo;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    countOrders() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let url = "/admin/count-order";
      this.axios
        .get(url, config)
        .then((response) => {
          let { data } = response.data;
          this.totalOrders = data[0].totalOrder;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    countValuation() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let url = "/admin/count-valuation";
      this.axios
        .get(url, config)
        .then((response) => {
          let { data } = response.data;
          this.totalValuations = data[0].countValuation;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    countOrderByDay() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let url = "/orders/count-orders-day";
      this.axios
        .get(url, config)
        .then((response) => {
          let { data } = response.data;
          for (var i in data) {
            this.chartData.datasets[0].data.push(data[i].count_order);
            this.chartData.labels.push(data[i].day);
          }
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },

    countMarketPlace() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let url = "/orders/count-market-place";
      this.axios
        .get(url, config)
        .then((response) => {
          let { data } = response.data;
          this.ordersMarketPlace = data;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
  },
  created() {
    this.countCategories();
    this.countProducts();
    this.countProfit();
    this.countCashflows();
    this.countOrders();
    this.countValuation();
    this.countOrderByDay();
    this.countMarketPlace();
  },
};
</script>
